import { render } from "./ResultScreen.vue?vue&type=template&id=59e92bc2&scoped=true"
import script from "./ResultScreen.vue?vue&type=script&lang=js"
export * from "./ResultScreen.vue?vue&type=script&lang=js"

import "./ResultScreen.vue?vue&type=style&index=0&id=59e92bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e92bc2"]])

export default __exports__